import { useContext, useEffect, useId, useRef } from 'react';
import { View } from 'react-native';
import { useIsFocused } from 'expo-router';
import { GuideContext } from './GuideProvider';

export default function GuideTarget({ id, children, style, activate, scrollRef, ...props }) {
    const guide = useContext(GuideContext);
    const instance = useId();
    const focused = useIsFocused();
    const node = useRef(null);
    const action = useRef(activate);
    action.current = activate;
    const scroll = useRef(scrollRef);
    scroll.current = scrollRef;
    const register = guide?.registerTarget;
    useEffect(() => {
        if (!register || !id) return;
        return register(id, instance, {
            // Lazy getter: recycled/virtualized targets (list rows, table
            // cells) get new DOM nodes without re-running this effect — a
            // snapshot would measure a detached node forever.
            get node() { return node.current; },
            focused, activate: activate ? () => action.current?.() : null,
            ensureVisible: () => {
                if (node.current?.scrollIntoView) return node.current.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'instant' });
                const scroller = scroll.current?.current;
                const content = scroller?.getInnerViewRef?.();
                if (content) node.current?.measureLayout(content, (_x, y) => scroller.scrollTo({ y: Math.max(0, y - 100), animated: false }), () => {});
            },
        });
    }, [register, id, instance, focused, !!activate, guide?.resetVersion, guide?.accountID]);
    return <View ref={node} collapsable={false} style={style} {...props} testID={props.testID || `guide-target-${id}`}>{children}</View>;
}
